export default "__VITE_ASSET__7640a56e__"